<template>
    <div id="geojsonViewer" style="text-align: left;">
        <pre>{{ JSON.stringify(jsonMapSpec, null, 4) }}</pre>
    </div>
</template>

<script>
import FromOMBMapSpec from '@/map/spec/FromOMBMapSpec'
import PublisherService from '@/service/PublisherService'
import MapService from '@/service/MapService'

export default {
    name: "MapDetail",
    props: [
        "publisherId",
        "bundleId",
        "mapDefinitionFilename"
    ],
    data() {
        return {
            internalNavigation: false,
            mapSpec: null,
            disableScrollZoom: false,
            jsonMapSpec: null,
            publisherService: new PublisherService(),
            mapService: new MapService()
        };
    },
    computed: {
        fullscreen() {
            return !this.internalNavigation;
        }
    },
    methods:{
        _handleMessageEvent(event) {
            const eventData = event.data;
            if (eventData) {
                if (eventData.name == "selectObject") {
                    const objectId = eventData.objectId;
                    if (objectId) {
                        this.$refs.mapboxMap.selectMapElement(objectId, true);
                    }
                }
            }

            // this.$refs.mapboxMap.
        }
    },
    mounted() {
        const language = this.$route.query.lang ? this.$route.query.lang : navigator.language.substr(0, 2);
        this.$i18n.locale = language;
        this.disableScrollZoom = this.$route.query.disableScrollZoom == "true";

        this.publisherService.loadPublishersForBundle(this.bundleId).then((publishers) => {
            var publisherId = null;
            if (publishers.length > 0) {
                publisherId = publishers[0].id;
            }

            this.mapService.loadMapsByMapDefinitionFilename(publisherId, this.mapDefinitionFilename + ".json").then((maps) => {
                if (maps.length > 0) {
                    const map = maps[0];
                    console.log(map);
                    this.mapSpec = new FromOMBMapSpec(this.$store.state.currentUser, publisherId, this.bundleId, map.id, language, this.$i18n, false);
                    this.mapSpec.load().then(() => {
                        document.title = this.mapSpec.name != "" ? "Ondago - " + this.mapSpec.name : "Ondago";
                        this.jsonMapSpec = this.mapSpec.toJSON();
                    }).catch((error) => {
                        console.log(error);
                    });
                }
            }).catch((error) => {
                console.log(error);
            });
        }).catch((error) => {
            console.log(error);
        });

        window.addEventListener("message", (event) => {
            this._handleMessageEvent(event);
        }, false);
    },
    destroyed() {
        // TODO
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.internalNavigation = from.name != null;
            vm.$store.state.fullscreen = !vm.internalNavigation;
        });
    },
    beforeRouteLeave (to, from, next) {
        this.$store.state.fullscreen = false;
        next();
    }
}
</script>

<style lang="scss" scoped>

#mapViewer {
    position: absolute;
    width: 100%;
    height: 100%;
}

</style>